import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { Input } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
import useProductName from "brand-customization/useProductName";
const PagerDutyNotificationForm = ({ config, validation, onChange }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
  const productName = useProductName();
  const propagateChange = (key, value) => {
    const nextConfig = cloneDeep(config);
    if ((key === "pager_duty_title" || key === "incident_key") && value === "") {
      nextConfig[key] = null;
    } else {
      nextConfig[key] = value;
    }
    onChange(nextConfig);
  };
  const handleChange = (event) => {
    const { name } = event.target;
    propagateChange(name, getValueFromInput(event.target));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-routing_key",
      name: "routing_key",
      label: "Routing Key",
      type: "text",
      bsStyle: validation.errors.routing_key ? "error" : null,
      help: (_c = (_b = (_a = validation.errors) == null ? void 0 : _a.routing_key) == null ? void 0 : _b[0]) != null ? _c : "The Pager Duty integration Routing Key.",
      value: config.routing_key,
      onChange: handleChange,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-pager_duty_title",
      name: "pager_duty_title",
      label: "Incident Title",
      type: "text",
      bsStyle: validation.errors.pager_duty_title ? "error" : null,
      help: (_f = (_e = (_d = validation.errors) == null ? void 0 : _d.pager_duty_title) == null ? void 0 : _e[0]) != null ? _f : `Custom title for the incident in Pager Duty. Will be the event title as shown in ${productName} if not set.`,
      value: config.pager_duty_title,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-custom_incident",
      name: "custom_incident",
      label: "Use Custom Incident Key",
      type: "checkbox",
      bsStyle: validation.errors.custom_incident ? "error" : null,
      help: (_i = (_h = (_g = validation.errors) == null ? void 0 : _g.custom_incident) == null ? void 0 : _h[0]) != null ? _i : "Generate a custom incident key.",
      checked: config.custom_incident,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-key_prefix",
      name: "key_prefix",
      label: "Incident Key Prefix",
      type: "text",
      bsStyle: validation.errors.key_prefix ? "error" : null,
      help: (_l = (_k = (_j = validation.errors) == null ? void 0 : _j.key_prefix) == null ? void 0 : _k[0]) != null ? _l : "Incident key prefix that will be followed by Stream(s) and the Event Definition title. Use Incident Key to customize entire key.",
      value: config.key_prefix,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-incident_key",
      name: "incident_key",
      label: "Incident Key",
      type: "text",
      bsStyle: validation.errors.incident_key ? "error" : null,
      help: (_o = (_n = (_m = validation.errors) == null ? void 0 : _m.incident_key) == null ? void 0 : _n[0]) != null ? _o : "Full key to identify the incident. Will be used instead of prefix, if provided.",
      value: config.incident_key,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-client_name",
      name: "client_name",
      label: "Client Name",
      type: "text",
      bsStyle: validation.errors.client_name ? "error" : null,
      help: (_r = (_q = (_p = validation.errors) == null ? void 0 : _p.client_name) == null ? void 0 : _q[0]) != null ? _r : `The name of the ${productName} system that is triggering the PagerDuty event.`,
      value: config.client_name,
      onChange: handleChange,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-client_url",
      name: "client_url",
      label: "Client URL",
      type: "text",
      bsStyle: validation.errors.client_url ? "error" : null,
      help: (_u = (_t = (_s = validation.errors) == null ? void 0 : _s.client_url) == null ? void 0 : _t[0]) != null ? _u : `The URL of the ${productName} system that is triggering the PagerDuty event.`,
      value: config.client_url,
      onChange: handleChange,
      required: true
    }
  ));
};
export default PagerDutyNotificationForm;
